<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			d="M3.75586 8.00024H11.3286M7.9954 12.2427L12.2378 8.00024L7.9954 3.75781"
			stroke="currentColor"
			stroke-width="1.36364"
			stroke-linecap="square"
		/>
	</svg>
</template>
